import { put } from 'redux-saga/effects';
import { signOutSuccess } from '../auth/auth.actions';
import { showNotify } from '../notify/notify.actions';
import { collabReset } from '../collab/collab.actions';
import { notificationsReset } from '../notifications/notifications.actions';

/**
 * Called by either namespace saga when the backend emits 'session_expired'.
 * Clears auth + both socket-driven slices and toasts the user before the
 * app routes them back to /login (the existing auth redirect in App.js
 * picks up sessionStatus === 'not_authorized').
 */
export function* handleSessionExpired() {
    yield put(showNotify({ message: 'session_expired' }));
    yield put(collabReset());
    yield put(notificationsReset());
    yield put(signOutSuccess());
}
